module.exports = __webpack_public_path__ + "static/carlos_nogueira-e55f19c0aa84cd200011e3d9c4f70fa9.jpg";